import React, { useState, useEffect } from 'react';
import axios from 'axios';

import Head from "../../../layout/Head/Head";
import Breadcrumbs from '../../../components/Breadcrumbs/Breadcrumbs';
import EventCard from "./components/EventCard/EventCard";

import styles from './index.module.scss';
import Header from "../../../hoc/Header/Header";
import Container from "../../../hoc/Container/Container";
import Grid from "../../../hoc/Grid/Grid";
import Card from "../../../hoc/Card/Card";
import FormatDate from "../../../components/FormatDate/FormatDate";

import mainEventDecorator from '../../../assets/events/main-event-decorator.svg';

const EventsPage = (props) => {
  const [mainEvent, setMainEvent] = useState({});
  const [events, setEvents] = useState([]);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/api/collections/get/events`)
      .then(response => {
        const events = response.data.entries ? response.data.entries : [];
        setMainEvent(events.filter(event => event.mainEvent)[0]);
        setEvents(events.filter(event => !event.mainEvent));
      })

  }, []);

  events.sort((a, b) => (a.startDate > b.startDate) ? 1 : -1);

  return(
    <div className={styles['events-page-container']}>
      <Head title="Connatix - Events" />
      <Header>
        <Breadcrumbs {...props} hasBackground={false}/>
        { mainEvent ? 
          <div className={styles['main-event']}>
            <div className={styles['main-event__cover']}  style={{backgroundImage: `url(${process.env.REACT_APP_API_URL}/${mainEvent.eventCover && mainEvent.eventCover.path})`}}/>
            <div className={styles['main-event__content']}>
              {mainEvent.logo && mainEvent.logo.path ?
                <div className={styles['main-event__logo-container']}>
                  <img src={`${process.env.REACT_APP_API_URL}/${mainEvent.logo && mainEvent.logo.path}`} alt="" className={styles['main-event__logo']}/>
                </div>
                : undefined
              }

              <div className={styles['main-event__date-container']}>
                <span className={styles['main-event__date']}>
                  <FormatDate format="MMM Do YYYY" date={mainEvent.startDate}/>
                  {mainEvent.endDate ? ' - ' : undefined}
                  {mainEvent.endDate ?
                    <FormatDate format="MMM Do YYYY" date={mainEvent.endDate}/>
                    : undefined
                  }
                </span>
                <img src={mainEventDecorator} alt="" className={styles['main-event__date-decorator']}/>
              </div>

              <h1 className={styles['main-event__name']}>{mainEvent.name}</h1>
              <p className={styles['main-event__description']}>{mainEvent.description}</p>
              <a href={mainEvent.eventURL}
                target="_blank"
                rel="noopener noreferrer"
                className={styles['main-event__button']}>
                {mainEvent.buttonText}
              </a>
            </div>
          </div>
        : undefined }
      </Header>

      <main className={styles['events']}>
        <Container>         
          <Grid>
            {events.map(event => (
              <Card key={event._id}>
                <EventCard {...event}/>
              </Card>
            ))}
          </Grid>
        </Container>
      </main>
    </div>
  );
};

export default EventsPage;
